import React, { useState, useEffect } from "react";
import { useParams, Link as RouterLink, useNavigate } from "react-router-dom";
import { Box, Card, Snackbar, Typography } from "@mui/material";
import { BrandContext } from "../../App";

import Moment from "moment";

import { CallScreen } from "../../components/complex/CallScreen";

import { useTheme } from "@mui/material/styles";
import ScenarioDetailsInfoPanel from "../../components/complex/ScenarioDetailsInfoPanel";

import ScenarioDetailsSidePanel from "../../components/complex/ScenarioDetailsSidePanel";

import VideoAvatar from "../../components/VideoAvatar/VideoAvatar";

import Cookies from "js-cookie";

import { useAPI } from "../../hooks/useAPI";

import { useAuth } from "../../contexts/AuthContext";
import { useUI } from "../../contexts/UIContext";

export default function ScenarioDetails() {
  const { brand, simulations, refreshSimulations } =
    React.useContext(BrandContext);
  const { callAPI } = useAPI();
  const [simulationId, setSimulationId] = React.useState(null);
  const [simulationData, setSimulationData] = React.useState(null);
  const [scenarioData, setScenarioData] = React.useState(null);
  const [trainingProgram, setTrainingProgram] = React.useState(null);

  const [firstScenario, setFirstScenario] = React.useState(true);
  const [simulationCallURL, setSimulationCallURL] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [showCallScreen, setShowCallScreen] = React.useState(true);

  const { setSideMenuOpen } = useUI();

  const [integrationType, setIntegrationType] = React.useState(null);
  const theme = useTheme();

  const [hasCompletedSim, setHasCompletedSim] = useState(false);

  const { scenario_id } = useParams();
  const navigate = useNavigate();

  const { authToken, loggedInUser } = useAuth();

  Moment.locale("en");

  useEffect(() => {
    if (Cookies.get("GN-CompletedSim")) {
      setHasCompletedSim(true);
    }
  }, []);

  useEffect(() => {
    simulationId != null && setSideMenuOpen(false);
  }, [simulationId]);

  React.useEffect(() => {
    document.title = `Simulate - ${brand.name}`;
  }, [loggedInUser]);

  const [value, setValue] = React.useState(0);

  useEffect(() => {
    if (!scenario_id || !authToken || !brand.api_base_url) return;
    const controller = new AbortController();

    (async () => {
      try {
        const res = await callAPI(`scenario?scenario_id=${scenario_id}`, {
          token: authToken,
        });
        setScenarioData(res);
        if (res.resources?.length) setValue(1);
        if (simulations.all.length > 0) setFirstScenario(false);
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Error fetching scenario:", err);
        }
      }
    })();

    return () => controller.abort();
  }, [scenario_id, authToken, brand.api_base_url]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  console.log(simulationData);

  useEffect(() => {
    if (simulationData && simulationData?.type)
      setIntegrationType(simulationData.type);
  }, [simulationData?.type]);

  // get simulations for this specific scenario from context
  const scenarioSimulations = React.useMemo(() => {
    return simulations.all.filter((sim) => sim.scenario_id === scenario_id);
  }, [simulations.all, scenario_id]);

  if (!scenarioData) {
    return (
      <Card
        sx={{
          mb: theme.customSpacing["4xl"],
          padding: theme.containers.paddingDesktop,
          color: theme.palette.text.secondary,
          border: `2px solid ${theme.palette.border.tertiary}`,
          borderRadius: theme.shape.radius,
          textAlign: "center",
          backgroundColor: "transparent",
        }}
      >
        <Typography sx={{ fontWeight: theme.typography.fontWeightMedium }}>
          Your simulation challenge is still loading...
        </Typography>
        <Typography sx={{ color: theme.palette.text.gray }}>
          If this takes too long, please refresh the page.
        </Typography>
      </Card>
    );
  }

  return (
    <React.Fragment>
      <Snackbar
        open={!!snackbarMessage}
        autoHideDuration={5000}
        onClose={() => setSnackbarMessage("")}
        message={snackbarMessage}
      />

      {/* <>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          sx={{ width: 1, height: "85vh", display: loading ? "flex" : "none" }}
        >
          <CircularProgress />
        </Stack>
      </> */}

      {/* Scenario loading state */}
      {!scenarioData && !loading ? (
        <Card
          sx={{
            mb: theme.customSpacing["4xl"],
            padding: theme.containers.paddingDesktop,
            color: theme.palette.text.secondary,
            border: `2px solid ${theme.palette.border.tertiary}`,
            borderRadius: theme.shape.radius,
            textAlign: "center",
            backgroundColor: "transparent",
          }}
        >
          <Typography sx={{ fontWeight: theme.typography.fontWeightMedium }}>
            Your simulation challenge is still loading...
          </Typography>
          <Typography sx={{ color: theme.palette.text.gray }}>
            If this takes too long, please refresh the page.
          </Typography>
        </Card>
      ) : (
        <>
          {simulationId == null ? (
            // -------- BEFORE SIMULATION STARTS --------
            <Box
              sx={{
                display: "flex",
                gap: "20px",
                [theme.breakpoints.down("lg")]: {
                  flexDirection: "column",
                },
                "@media (max-width:1300px)": {
                  flexDirection: "column",
                },
              }}
            >
              <ScenarioDetailsInfoPanel
                scenarioData={scenarioData}
                loading={loading}
                difficulty_level={trainingProgram?.difficulty_level}
                setLoading={setLoading}
                setSimulationData={setSimulationData}
                setSimulationId={setSimulationId}
                setSimulationCallURL={setSimulationCallURL}
                setSnackbarMessage={setSnackbarMessage}
              />
              <ScenarioDetailsSidePanel
                value={value}
                handleChange={handleChange}
                scenarioData={scenarioData}
                trainingProgram={trainingProgram}
                simulationHistory={scenarioSimulations}
              />
            </Box>
          ) : (
            // -------- DURING SIMULATION --------
            <div style={{ display: loading ? "none" : "flex" }}>
              {integrationType === "video" ? (
                <VideoAvatar
                  config={simulationData || {}}
                  scenario={scenarioData}
                />
              ) : integrationType === "unity" ? (
                <CallScreen
                  url={simulationCallURL}
                  scenarioData={scenarioData}
                  firstScenario={firstScenario}
                  simulationData={simulationData}
                  style={{ display: showCallScreen ? "block" : "none" }}
                />
              ) : null}
            </div>
          )}
        </>
      )}
    </React.Fragment>
  );
}
